import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {WcvDocument} from '../../graphql/documents.datatypes';

interface DocumentData {
    document: WcvDocument
}

const gqlChildDocument = `
    id
    parent_document_id
    user_id
    type
    type_id
    title
    description
    url

    available_for_download
    has_completion_date
    completion_date
    verified
    tour_role

    user {
        id
        email
    }
    targetResource {
        id
    }
    targetGroup {
        id
    }
    targetGroupMember {
        id
        first_name
        last_name
    }
    
    overdueGroupMembers {
        id
        first_name
        last_name
        
        group {
            id
            name
        }
    }
`;

export const gqlDocument = `
    ${gqlChildDocument}

    completed_documents {
        ${gqlChildDocument}
    }
`;

export const GET_DOCUMENT_QUERY = gql`
    query getDocument($id: Int!){
        document(id: $id){
            ${gqlDocument}
        }
    }
`;

export const getDocument = (id: number) => useQuery<DocumentData>(
    GET_DOCUMENT_QUERY,
    {
        variables: {
            id,
        },
        
    }
);

export default getDocument;